import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { ReservationStore } from '../service/reservation-store';
import { DateRoomType } from '../models/date-room-type';
import { OverviewStore } from '../service/overview.store';
import { List } from 'immutable';

@Injectable()
export class OverviewResolver implements Resolve<any> {
  constructor(private overviewStore: OverviewStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<DateRoomType>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_OVERVIEW'));
    }

    if (eventPartyId) {
      return this.overviewStore.loadDateRoomTypeSummaryByParty(id, eventPartyId);
    } else {
      return this.overviewStore.loadDateRoomTypeSummary(id);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/overview.resolver.ts